import { Toast } from "../components/toast";
import { Helpers } from "../../helpers";

class HomeDiv extends HTMLDivElement {
    constructor() {
        super(); // Llama al constructor de HTMLElement
    }

    connectedCallback() {
        this.load();
        this.events();
    }

    load() {
        // console.log(this);
    }

    events() {
        this.addEventListener("click", (e) => {
            const updateDate = e.target.closest("._input_group_text");

            if (updateDate) {
                const url = updateDate.getAttribute("data-url");
                if (url) {
                    const Help = new Helpers();
                    Help.createForm(url, {
                        expires_at: updateDate.previousElementSibling.value,
                    });
                }
            }

            const regenerate = e.target.closest("[name=regenerateToken]");

            if (regenerate) {
                const url = regenerate.getAttribute("data-url");
                if (url) {
                    const Help = new Helpers();
                    Help.createForm(url, {});
                }
            }
        });
    }
}

customElements.define("home-div", HomeDiv, { extends: "div" });
